import { toast } from '../components/ui';

export const showServerErrors = (error: any) => {
    let message: string = error?.response?.data?.message || error?.message;
    toast.error(message);
};
